import { useEffect, useState } from "react";
import { useSubscriptionVersion } from "../../../../core/Global";
import SubscriptionManage from "../components/SubscriptionManage";
import AddonsCard from "../components/AddonsCard";


// The subscription, and under it what has been added to it.
//
// Two cards rather than one, because they are two questions -- what am I paying every month, and
// what have I bolted on -- but on one page, because the answer to the second only makes sense
// beside the first: half of what is on the wall is there because the plan put it there.
export default function SubscriptionView() {

    // Bumped when an add-on changes what the plan card shows -- extra users are counted in its
    // "Concurrent users" figure -- so the card above re-reads the plan instead of waiting for a
    // refresh of the whole page.
    const [planVersion, planVersionSet] = useState<number>(0)

    // The hub's single "SubscriptionChanged" signal. Everything on the page reads itself again
    // from this one number, rather than each part listening for its own event.
    const live = useSubscriptionVersion()

    // The one thing no event can announce: somebody who simply stops using the product drops out
    // of "signed in now" when the 15-minute window runs out, with nothing sent at that moment.
    // A quiet re-read every two minutes catches it.
    useEffect(() => {
        const timer = setInterval(() => planVersionSet(v => v + 1), 2 * 60 * 1000)
        return () => clearInterval(timer)
    }, [])

    const key = planVersion + live

    return (
        <>
            <SubscriptionManage refreshKey={key} />
            <AddonsCard refreshKey={key} onChanged={() => planVersionSet(v => v + 1)} />
        </>
    )
}
